import { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { CartProvider } from "./context/CartContext";
import { StoreProvider } from "./context/StoreContext";
import { AdminAuthProvider } from "./context/AdminAuthContext";
import Header from "./components/Header";
import Footer from "./components/Footer";
import CartDrawer from "./components/CartDrawer";
import TruthPopup from "./components/TruthPopup";
import Home from "./pages/Home";
import Shop from "./pages/Shop";
import Story from "./pages/Story";
import ProductDetail from "./pages/ProductDetail";
import Faq from "./pages/Faq";
import LegalPage from "./pages/LegalPage";
import SoldNotification from "./components/SoldNotification";
import AdvisorChat from "./components/AdvisorChat";

import AdminLogin from "./pages/admin/AdminLogin";
import AdminLayout from "./pages/admin/AdminLayout";
import Overview from "./pages/admin/Overview";
import AdminProducts from "./pages/admin/AdminProducts";
import AdminSections from "./pages/admin/AdminSections";
import AdminOrders from "./pages/admin/AdminOrders";
import AdminSubscriptions from "./pages/admin/AdminSubscriptions";
import AdminEmail from "./pages/admin/AdminEmail";
import AdminChannels from "./pages/admin/AdminChannels";
import AdminSettings from "./pages/admin/AdminSettings";
import HiddenTruth from "./pages/HiddenTruth";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
};

const Storefront = () => (
  <CartProvider>
    <TruthPopup />
    <Header />
    <main>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/shop" element={<Shop />} />
        <Route path="/shop/:category" element={<Shop />} />
        <Route path="/our-story" element={<Story />} />
        <Route path="/the-hidden-truth" element={<HiddenTruth />} />
        <Route path="/product/:slug" element={<ProductDetail />} />
        <Route path="/faq" element={<Faq />} />
        <Route path="/disclaimer" element={<LegalPage type="disclaimer" />} />
        <Route path="/policies" element={<LegalPage type="privacy" />} />
        <Route path="/terms" element={<LegalPage type="terms" />} />
      </Routes>
    </main>
    <Footer />
    <CartDrawer />
    <SoldNotification />
    <AdvisorChat />
  </CartProvider>
);

function App() {
  return (
    <div className="App min-h-screen bg-background">
      <BrowserRouter>
        <AdminAuthProvider>
          <StoreProvider>
            <ScrollToTop />
            <Routes>
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route path="/admin" element={<AdminLayout />}>
                <Route index element={<Overview />} />
                <Route path="products" element={<AdminProducts />} />
                <Route path="sections" element={<AdminSections />} />
                <Route path="orders" element={<AdminOrders />} />
                <Route path="subscriptions" element={<AdminSubscriptions />} />
                <Route path="channels" element={<AdminChannels />} />
                <Route path="email" element={<AdminEmail />} />
                <Route path="settings" element={<AdminSettings />} />
              </Route>
              <Route path="/*" element={<Storefront />} />
            </Routes>
          </StoreProvider>
        </AdminAuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
